import { Box, Button, Heading, Text, Stack } from '@chakra-ui/react'
import { Link } from 'react-router-dom'

export const HeroSection = () => (
  <Box as="section" bg="bg.canvas" textAlign="center" py={{ base: 20, md: 28 }} px={4}>
    <Heading as="h1" size="2xl" mb={5} color="text.engraved">
      Put it onchain, not on paper.
    </Heading>
    <Text fontSize="xl" mb={10} color="text.muted" maxW="2xl" mx="auto">
      A public, auditable way to sacrifice tokens across 31 blockchains. No intermediaries. No
      paper.
    </Text>
    <Stack direction={{ base: 'column', sm: 'row' }} spacing={4} justify="center">
      <Button as={Link} to="/sacrifices" variant="flame" size="lg" px={8}>
        View campaigns
      </Button>
      <Button as={Link} to="/compose" variant="engrave" size="lg" px={8}>
        Create a project
      </Button>
      <Button as="a" href="#how-it-works" variant="engrave" size="lg" px={8}>
        How it works
      </Button>
    </Stack>
  </Box>
)

export default HeroSection
